import { mount } from 'enzyme';
import * as React from 'react';

import { BackNextSkip } from './backnextskip';

describe('Button', () => {
  test('should match snapshot and styles for default props', () => {
    expect(
      mount(
        <BackNextSkip
          backButtonClassName={'button button-secondary button-lg'}
          backButtonText={'BACK'}
          nextButtonClassName={'button button-primary button-lg ml-2'}
          nextButtonText={'NEXT'}
        />,
      ),
    ).toMatchSnapshot();
  });

  test('should match snapshot and styles for default props', () => {
    expect(
      mount(
        <BackNextSkip
          backButtonClassName={'button button-secondary button-lg'}
          backButtonText={'BACK'}
          nextButtonClassName={'button button-primary button-lg ml-2'}
          nextButtonText={'NEXT'}
          skipText={'skip'}
        />,
      ),
    ).toMatchSnapshot();
  });
});
